module.exports = __webpack_public_path__ + "img/book-08.2c87a71f.png";